import { MyTasksService } from '@affine/core/modules/my-tasks';
import { WorkbenchService } from '@affine/core/modules/workbench';
import { useI18n } from '@affine/i18n';
import { CheckBoxCheckLinearIcon } from '@blocksuite/icons/rc';
import { useLiveData, useService } from '@toeverything/infra';

import { MenuLinkItem } from '../../modules/app-sidebar/views';

export const MyTasksButton = () => {
  const t = useI18n();
  const myTasksService = useService(MyTasksService);
  const workbench = useService(WorkbenchService).workbench;

  const openCount = useLiveData(myTasksService.openCount$);
  const location = useLiveData(workbench.location$);
  const active = location.pathname.startsWith('/my-tasks');

  return (
    <MenuLinkItem
      data-testid="my-tasks-button"
      active={active}
      to={'/my-tasks'}
      icon={<CheckBoxCheckLinearIcon />}
      postfix={
        openCount > 0 ? (
          <span
            style={{
              fontSize: 12,
              fontFeatureSettings: 'tnum',
              color: 'var(--affine-v2-text-secondary)',
            }}
          >
            {openCount > 99 ? '99+' : openCount}
          </span>
        ) : undefined
      }
    >
      {t['com.affine.my-tasks.page-title']()}
    </MenuLinkItem>
  );
};
